if (!window.customElements.get("trustpilot-reviews")) {
    customElements.define(
        'trustpilot-reviews',
        class TrustpilotReviews extends HTMLElement {
            constructor() {
                super();
                
                this.template = document.querySelector('template[data-content="trustpilot-reviews"]');
                this.templateWrapper = this.querySelector(".trustpilot-widget__wrapper");
            }
            
            connectedCallback() {
                this.templateWrapper.innerHTML = this.template.innerHTML;
            }
        }
    );
}